import { NgModule, Optional, SkipSelf,
         ModuleWithProviders} from '@angular/core';

import { AuthService } from './Services/auth';
import { AlertService } from './Services/alert';
import { CartService } from './Services/cart';
import { Config } from './Services/config';
import { LanguageService } from './Services/lang';
import { OrderService } from './Services/order';


@NgModule({
  providers: [
    AuthService,
    AlertService,
    CartService,
    OrderService,
    Config,
    LanguageService
  ],
})

export class CoreModule {

  constructor (@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only');
    }
  }

  static forRoot(): ModuleWithProviders {
    return {
      ngModule: CoreModule,
      providers: [
        AuthService, CartService, AlertService, Config, LanguageService, OrderService,
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/core.module.ts